function AppointmentHeadersWS(viewModel) {
  // super
  AbstractWS.call(this, viewModel);

  this.name = "AppointmentHeadersWS";

  this.serviceURL = ko.computed(function () {
    return "/qless/api/v1/employee/appointments/headers";
  });
}

AppointmentHeadersWS.prototype = Object.create(AbstractWS.prototype);

/**
 * @typedef {Object} CalendarSelectedDateRange
 * @property {String} start the start date in YYYY-MM-DD format
 * @property {String} end  the end date in YYYY-MM-DD format
 * @property {String} timezone the Timezone. Example: "America/Los_Angeles"
 */

/**
 * @method
 * @param {Array<Number|String>} queueIds
 * @param {CalendarSelectedDateRange} dateRange
 * @param {Function} callback
 */
AppointmentHeadersWS.prototype.requestAppointments = function (
  queueIds,
  dateRange,
  callback
) {
  this.reset();
  this.addParam("start", dateRange.start);
  this.addParam("end", dateRange.end);
  this.addParam("timeZone", dateRange.timezone);
  this.addParam("queueIds", queueIds.join(","));
  this.doRequest(callback);
};

if (typeof exports !== "undefined") {
  exports.AppointmentHeadersWS = AppointmentHeadersWS;
}
